import React, { useRef, useState, useEffect } from 'react';
import { setupScene } from '../../../componentes/3d/QPMINI_6_ILUMINADO';
import { motion, AnimatePresence } from 'framer-motion';
import styled, { createGlobalStyle } from 'styled-components';
import { useInView } from "react-intersection-observer";
import fondo1 from './components/Fondo-quickpaymini.png';
import fondo2 from './components/Fondo-quickpay101.png';
import fondo3 from './components/Fondo-kioskopay.png';
import fondo4 from './components/Fondo-Quickpay301.png';
import billetes from './components/Billete.png';
import monedas from './components/monedas.png';
import logo1 from './components/interaccion.png';
import logo2 from './components/candado.png';
import org from './components/Organismos.png';
import tramites from './components/Tramites.png';
import negocios from './components/Negocios.png';
import monitor from './components/Monitor.png';
import estructura from './components/Estructura-robusta-segura.png';
import conexion from './components/conexion.png';
import seguridad from './components/seguridad.png';
import medidasqpmini from './components/QPM-Medidas.png';
import medidaskiosko from './components/Medidas-KS.png';
import espkiosko from './components/Kioskopay_3-4.png';
import medidasqp101 from './components/Medidas-QP101.png';
import frontal101 from './components/frontal-QP101.png';
import dudas101 from './components/Dudas-QP101.png';
import dudasks from './components/Dudas-KS.png';
import QPM from './components/QPM.png';
import dudas from './components/Dudas.png';
import giro from './components/360.png';
import boton from './components/360-Blanco.png';
import fajo from './components/Fajo-billetes.png';
import tactil from './components/Tablet-22.png';
import alarma from './components/Alarma.png';
import optimizacion from './components/Optimizacion.png';
import qp301 from './components/Medidas-QP301.png';
import dudasqp301 from './components/Dudas-Quickpay301.png';
import esp301 from './components/render-cajero-Quickpay301.png';
import { FaWhatsapp } from "react-icons/fa";



const productData = [
    {
        id: 1,
        title: "QuickpayMini",
        background: fondo1,
        modelo3d: boton,
        description: "Lleva tu punto de venta a donde vayas. Quickpaymini está diseñado para emprendedores, foodtrucks y pequeños comercios que necesitan una solución de cobro práctica, segura y con excelente presentación. Sin complicaciones, sin instalaciones complejas.",
        color: "#0d2b70",
        modelImage: "/models/QPM.png",
        nameModelo: "QPMINI",
        //scale: 0.5,
        imageSize: {
            width: "w-[500px]",

        },
        capacities: {
            features: [
                {
                    logo: billetes,
                    text: "Recibe hasta 600 billetes de distintas denominaciones"
                },
                {
                    logo: monedas,
                    text: "Integra 6 tubos configurables para reciclado de monedas"
                },
                {
                    logo: conexion,
                    text: "Conexión con distintos POS del mercado"
                },
                {
                    logo: seguridad,
                    text: "Cerradura física y electrónica de alta seguridad"
                }
            ]
        },
        // NUEVO: Información específica para el modal
        modalInfo: {
            medidas: {
                alto: "65 cm",
                ancho: "31 cm",
                fondo: "36 cm",
                imagen: medidasqpmini, // Imagen de medidas
                descripcion: "El QuickpayMini es compacto y fácil de colocar en mostradores o espacios reducidos.",
                descripcion2: "Ideal para integrarse a cualquier tipo de negocio sin obstruir el área de atención al cliente.",
                medidasImagen: {  // Medidas para la imagen de "medidas"
                    ancho: "350px",
                    alto: "400px",
                    margen: "0 auto"
                }
            },
            especificaciones: {
                lista: [
                    "Tablet de 7” para interacción directa.",
                    "Acepta pagos en efectivo y tarjeta.",
                    "Fácil adaptabilidad de pago con tarjeta",
                    "Conexión vía WiFi o Ethernet.",
                    "Compatible con Sicar, Softrestaurant, Micosip, Aspel SAE y POS Empatica.",
                    "Sistema de corte de caja automático.",
                    "Cajón de seguridad con llave y estructura metálica con placa de anclaje",
                    "Adaptable a tu sistema POS"
                ],
                imagen: QPM,
                brochureUrl: "https://drive.google.com/file/d/1kvlNFh45jCDuidQhWxdocPLiRYgaxqPz/view",
                medidasImagen: {
                    ancho: "400px",
                    alto: "400px",
                    margen: "0 auto"
                }
            },
            dudas: {
                preguntas: [
                    {
                        pregunta: "¿Qué tipos de pago acepta?",
                        respuesta: "Acepta pagos en efectivo, además cuenta con la posibilidad de adaptarse una terminal de pagos con tarjetas de crédito y débito."
                    },
                    {
                        pregunta: "¿Es necesario tener un sistema POS para usarlo?",
                        respuesta: "No es obligatorio, ya que el cajero puede funcionar de forma autónoma. Sin embargo, sí se recomienda integrarlo a un sistema POS para optimizar cortes de caja, registro de ventas y sincronización de datos, especialmente en negocios con alto volumen de operación."
                    },
                    {
                        pregunta: "¿Qué tipo de seguridad ofrece?",
                        respuesta: "Cuenta con una placa de anclaje al piso, chapa de seguridad física y cerradura electrónica, brindando protección tanto contra intentos de apertura no autorizada como contra movimientos indebidos del equipo."
                    },
                    {
                        pregunta: "¿Puede integrarse con diferentes sistemas?",
                        respuesta: "Sí. El Quickpaymini es compatible con sistemas de punto de venta como Sicar, Softrestaurant y POS Empatica, y también se puede integrar mediante API con otros sistemas personalizados."
                    },
                ],
                imagen: dudas,
                medidasImagen: {  // Medidas para la imagen de "especificaciones"
                    alto: "400px",
                    ancho: "400px",
                    margen: "0 auto"
                }
            },
            modelo: {
                descripcion: "Interactúa y conoce el QuickpayMini en 360°.",
                imagenGiro: giro,
                whatsapp: "https://wa.me/524434799929?text=Hola%20Equipo%20de%20Empatica,%20v%C3%AD%20tu%20pagina%20y%20me%20interesa%20m%C3%A1s%20informaci%C3%B3n%20del%20Quickpaymini",
                medidasImagen: {
                    ancho: "250px",
                    alto: "250px",
                    margen: "0 auto"
                }
            }
        },
    },
    {
        id: 2,
        title: "Quickpay101",
        background: fondo2,
        description: "Agilidad, estética y funcionalidad para puntos de venta de atención rápida. Ideal para restaurantes, cadenas de tiendas o mostradores que buscan eficiencia sin perder diseño. QuickPay101 ofrece una experiencia de usuario fluida para clientes y operadores.",
        color: "#0d2b70",
        modelImage: "/models/Cajero-Quickpay101.png",
        nameModelo: "KP101",
        imageSize: {
            width: "w-[325px]",
        },
        capacities: {

            features: [
                {
                    logo: billetes,
                    text: "Capacidad de hasta 1000 billetes"
                },
                {
                    logo: monitor,
                    text: "Monitor Touchscreen de 15'"
                },
                {
                    logo: negocios,
                    text: "Ideal para negocios de medio-alto volumen"
                },
                {
                    logo: estructura,
                    text: "Estructura robusta y segura"
                }
            ]
        },
        // NUEVO: Información específica para el modal
        modalInfo: {
            medidas: {
                alto: "150 cm",
                ancho: "40 cm",
                fondo: "52 cm",
                imagen: medidasqp101,
                brochureUrl: "https://drive.google.com/file/d/1krgDXEuVtgavHlp_POU7ANCbcP6Iqdzy/view",
                descripcion: "El Quickpay101 es un modelo versátil con mayor capacidad de dinero que el Quickpaymini, ideal para negocios con más flujo de efectivo o necesidades más robustas.",
                descripcion2: "Su diseño compacto lo hace ideal para mostradores o módulos de autoservicio.",
                medidasImagen: {
                    ancho: "350px",
                    alto: "400px",
                    margen: "0 auto"
                }
            },
            especificaciones: {
                lista: [
                    "Pantalla táctil de 15”",
                    "Acepta pagos con efectivo",
                    "Bandeja de billetes con mayor capacidad que el Quickpaymini (hasta 800 billetes).",
                    "Hecho para operar 24/7",
                    "Puede administrar pago con tarjeta (Consultar TyC.)",
                    "Capaz de operar con autonomia para autoservicio",
                    "Chasis metálico de alto calibre con cerraduras de seguridad."
                ],
                imagen: frontal101,
                brochureUrl: "https://drive.google.com/file/d/1krgDXEuVtgavHlp_POU7ANCbcP6Iqdzy/view",
                medidasImagen: {
                    ancho: "400px",
                    alto: "400px",
                    margen: "0 auto"
                }
            },
            dudas: {
                preguntas: [
                    {
                        pregunta: "¿Qué diferencia entre el Quickpay101 y Quickpaymini?",
                        respuesta: "El Quickpay101 está diseñado para negocios con mayor flujo de efectivo. Cuenta con una pantalla táctil de 15”, capacidad ampliada para billetes y monedas, y un sistema de reciclado de efectivo que permite entregar cambio automáticamente, reduciendo la necesidad de intervención constante."
                    },
                    {
                        pregunta: "¿Qué medidas de seguridad tiene?",
                        respuesta: "El equipo cuenta con tres cerraduras mecánicas y una cerradura electrónica de 300 kg de presión, además de la opción de ser anclado al piso mediante una placa de acero o empotrado a la pared, lo que garantiza estabilidad y protección contra intentos de manipulación."
                    },
                    {
                        pregunta: "¿Puede usarse como autoservicio?",
                        respuesta: "Definitivamente. Su pantalla intuitiva, múltiples métodos de pago y autonomía operativa lo hacen ideal para puntos de autoservicio, donde los usuarios pueden pagar sin asistencia directa."
                    },
                    {
                        pregunta: "¿Qué pasa si hay una falla de energía?",
                        respuesta: "El equipo está equipado con un regulador de voltaje y sistema No Break (UPS) que le permite seguir operando hasta por 30 minutos tras una interrupción eléctrica, asegurando el cierre adecuado de operaciones sin pérdida de datos."
                    }
                ],
                imagen: dudas101,
                medidasImagen: {
                    ancho: "500px",
                    alto: "300px",
                    margen: "0 auto"
                }
            },
            modelo: {
                descripcion: "Interactúa y conoce el Quickpay101 en 360°.",
                imagenGiro: giro, // Imagen del botón de 360°
                whatsapp: "https://wa.me/524434799929?text=Hola%20Equipo%20de%20Empatica,%20v%C3%AD%20tu%20pagina%20y%20me%20interesa%20m%C3%A1s%20informaci%C3%B3n%20del%20Quickpay101" // Enlace de WhatsApp
            }
        },
    },
    {
        id: 3,
        title: "Kioskopay",
        background: fondo3,
        description: "Kioskopay es un quiosco de autoservicio diseñado para recibir pagos de forma rápida, segura y sin necesidad de personal. Ideal para espacios públicos o negocios con alto flujo de usuarios, permite pagar servicios, imprimir comprobantes y consultar información de manera sencilla e intuitiva.",
        color: "#0d2b70",
        modelImage: "/models/Kioskopay.png",
        nameModelo: "Kioskopay",
        imageSize: {
            width: "w-[500px]"
        },
        capacities: {

            features: [
                {
                    logo: logo1,
                    text: "Interfaz amigable y fácil de usar"
                },
                {
                    logo: logo2,
                    text: "Pagos seguros, sin filas ni intermediarios"
                },
                {
                    logo: org,
                    text: "Ideal para organismos y espacios públicos"
                },
                {
                    logo: tramites,
                    text: "Compatible con trámites y consultas múltiples"
                }
            ]
        },
        // NUEVO: Información específica para el modal
        modalInfo: {
            medidas: {
                alto: "37 cm",
                ancho: "33 cm",
                fondo: "10 cm",
                imagen: medidaskiosko,
                descripcion: "El Kioskopay está diseñado para espacios públicos y puntos de alto flujo, con una estructura robusta pero accesible.",
                descripcion2: "Ideal para ser colocado en recepciones, oficinas gubernamentales, plazas o entradas de organismos operadores.",
                medidasImagen: {
                    ancho: "400px",
                    alto: "400px",
                    margen: "0 auto"
                }
            },
            especificaciones: {
                lista: [
                    "Pantalla HD de 11.6” con 10 puntos táctiles.",
                    "Disco duro SSD de 32/64 GB y RAM de 4 GB para operación fluida.",
                    "Impresora térmica de 80mm para tickets y comprobantes.",
                    "Se puede adaptar una terminal para pago con tarjeta",
                    "Lector de códigos de barras y QR desde papel o celular.",
                    "Conectividad: Ethernet 10/100 Mbps, WiFi y NFC integrados",
                    "Altavoces para reproducción de audio e instrucciones."
                ],
                imagen: espkiosko,
                brochureUrl: "https://drive.google.com/file/d/1NNoWDEgMjQXVn8-b8PjConIpJ5RAc_u5/view",
                medidasImagen: {
                    ancho: "400px",
                    alto: "400px",
                    margen: "0 auto"
                }
            },
            dudas: {
                preguntas: [
                    {
                        pregunta: "¿Es fácil de usar para cualquier persona?",
                        respuesta: "Sí. El kioskopay cuenta con una pantalla HD táctil de 11.6” con interfaz intuitiva y receptiva, lo que facilita su uso para todo tipo de usuarios, incluso aquellos con poca experiencia en tecnología. Además, puede incluir instrucciones guiadas por voz gracias a sus altavoces integrados."
                    },
                    {
                        pregunta: "¿Qué tan seguro es el equipo?",
                        respuesta: "El Kioskopay mejora la seguridad en los puntos de pago al reducir la manipulación de efectivo y minimizar el contacto directo entre personal y usuarios."
                    },
                    {
                        pregunta: "¿Puede funcionar sin conexión a internet?",
                        respuesta: "No. Para garantizar el procesamiento en tiempo real de pagos, validaciones y generación de comprobantes, el Kioskopay requiere conexión a internet. Es compatible con redes Ethernet y WiFi."
                    },
                    {
                        pregunta: "¿Qué ventajas ofrece el Kioskopay en comparación con una ventanilla tradicional?",
                        respuesta: "Permite atención 24/7 sin necesidad de personal, agiliza pagos, reduce filas y optimiza los recursos operativos. Esto se traduce en mayor eficiencia y una experiencia más cómoda para el usuario final."
                    },
                ],
                imagen: dudasks,
                medidasImagen: {
                    ancho: "400px",
                    alto: "400px",
                    margen: "0 auto"
                }
            },
            modelo: {
                descripcion: "Interactúa y conoce el Kioskopay en 360°.",
                imagenGiro: giro, // Imagen del botón de 360°
                whatsapp: "https://wa.me/524434799929?text=Hola%20Equipo%20de%20Empatica,%20v%C3%AD%20tu%20pagina%20y%20me%20interesa%20m%C3%A1s%20informaci%C3%B3n%20del%20Kioskopay" // Enlace de WhatsApp
            }
        },

    },
    {
        id: 4,
        title: "Quickpay301",
        background: fondo4,
        description: "El Quickpay301 es el cajero más robusto de la línea Quickpay, diseñado para negocios y entidades con alto volumen de transacciones en efectivo. Su capacidad para recibir fajos de hasta 50 billetes y dispensar cambio automáticamente lo convierte en la solución perfecta para puntos de pago con gran flujo.",
        color: "#0d2b70",
        modelImage: "/models/Cajero-Quickpay301.png",
        nameModelo: "Kioskopay",
        imageSize: {
            width: "w-[170px]"
        },
        capacities: {

            features: [
                {
                    logo: fajo,
                    text: "Recibe fajos de hasta 50 billetes por operación"
                },
                {
                    logo: tactil,
                    text: "Pantalla táctil de 22'' amplia, ágil y fácil de usar"
                },
                {
                    logo: alarma,
                    text: "Seguridad reforzada con alarma y cerraduras internas que protegen el equipo en todo momento"
                },
                {
                    logo: optimizacion,
                    text: "Reduce filas y carga operativa optimizando la atención"
                }
            ]
        },
        // NUEVO: Información específica para el modal
        modalInfo: {
            medidas: {
                alto: "160 cm",
                ancho: "55 cm",
                fondo: "80 cm",
                imagen: qp301,
                descripcion: "El Quickpay301 es el modelo más grande de la línea, diseñado para ofrecer máxima capacidad, seguridad y autonomía operativa",
                descripcion2: "Área recomendada para instalación: 100 cm x 120 cm",
                medidasImagen: {
                    ancho: "400px",
                    alto: "400px",
                    margen: "0 auto"
                }
            },
            especificaciones: {
                lista: [
                    "Acepta pagos en efectivo en grandes capacidades (billetes y monedas).",
                    "Billetero electrónico con capacidad de almacenar 1,500 billetes.",
                    "Dispensador de billetes en fajos de hasta 20 billetes.",
                    "Monedero electrónico con reciclador y 2 hoppers con capacidad de 3,000 monedas.",
                    "Lector de códigos 1D, 2D, PDF, QR (papel o pantalla).",
                    "Lector biométrico de huella digital.",
                    "Sensores con Alarma GSM para ATM",
                    "Regulador de voltaje con batería UPS (hasta 30 min)."
                ],
                imagen: esp301,
                brochureUrl: "",
                medidasImagen: {
                    ancho: "400px",
                    alto: "400px",
                    margen: "0 auto"
                }
            },
            dudas: {
                preguntas: [
                    {
                        pregunta: "¿Para qué tipo de negocios está pensado el Quickpay301?",
                        respuesta: "Está diseñado para negocios con operaciones de alto volumen de efectivo, como instituciones públicas, oficinas de trámites, servicios, bancos o empresas con múltiples transacciones diarias."
                    },
                    {
                        pregunta: "¿Cuántos billetes puede aceptar y dispensar?",
                        respuesta: "Acepta hasta 1,500 billetes en fajo de 50 y puede entregar hasta 20 billetes por transacción."
                    },
                    {
                        pregunta: "¿Cómo funciona el Sistema de Alarma?",
                        respuesta: "Funciona por medio de un sensor que tiene la posibilidad de alertar sobre cualquier intrusión al equipo ya que detecta vibraciones, cambios de temperatura, golpes e incluso el uso de herramientas como taladros o sopletes."
                    },
                    {
                        pregunta: "¿Puede ser utilizado en exterior?",
                        respuesta: "No, el Quickpay301 está diseñado para trabajar únicamente en interiores. No debe de exponerse al agua ni tampoco a las altas temperaturas provocadas por la exposición directa a los rayos solares."
                    },
                ],
                imagen: dudasqp301,
                medidasImagen: {
                    ancho: "400px",
                    alto: "400px",
                    margen: "0 auto"
                }
            },
            modelo: {
                descripcion: "Interactúa y conoce el Kioskopay en 360°.",
                imagenGiro: giro,
                whatsapp: "https://wa.me/524434799929?text=Hola%20Equipo%20de%20Empatica,%20v%C3%AD%20tu%20pagina%20y%20me%20interesa%20m%C3%A1s%20informaci%C3%B3n%20del%20Kioskopay" // Enlace de WhatsApp
            }
        },

    },

];

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'MiFuente';
    src: url('../../../fonts/CenturyGothic.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;

const FontStyle = createGlobalStyle`
  @font-face {
    font-family: 'MiFuente2';
    src: url('../../../fonts/Century Gothic.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;



const Banner3 = () => {
    const [showModal, setShowModal] = useState(false);
    const [tab, setTab] = useState("medidas");
    const [currentProduct, setCurrentProduct] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    const mountRef = useRef(null);
    const tabs = productData[currentProduct].id !== 4
        ? ["medidas", "especificaciones", "preguntas frecuentes", "modelo"]
        : ["medidas", "especificaciones", "preguntas frecuentes"];
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
    const [openIndex, setOpenIndex] = useState(null);

    /* useEffect(() => {
         //const modelName = modelo || productData[currentProduct].modelo; 
         const modelName = "QPMINI";
         const cleanup = setupScene(mountRef, modelName);
         return cleanup;
     }, [currentProduct]);*/


    useEffect(() => {
        let cleanup = null;
        if (tab == "modelo") {
            const modelName = productData[currentProduct].nameModelo;
            console.log(tab, modelName)
            cleanup = setupScene(mountRef, modelName);
            return cleanup;
        }

    }, [tab, currentProduct]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (showModal) {
            // Guardar la posición actual del scroll
            const scrollY = window.scrollY;
            if (document && document.body) {
                document.body.style.position = 'fixed';
                document.body.style.top = `-${scrollY}px`;
                document.body.style.width = '100%';
                document.body.style.overflow = 'hidden';
            }
        } else {
            if (document && document.body) {
                // Restaurar la posición del scroll
                const scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                document.body.style.overflow = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        }
    }, [showModal]);

    return (
        <BannerContainer ref={ref} id="productos" gradientStart={productData[currentProduct].color} gradientEnd="#0d2b70">
            <ContentWrapper>
                {/* Animación desde la izquierda */}
                <motion.div
                    className="order-1 md:order-none"
                    initial={{ x: -300, opacity: 0 }}
                    animate={inView ? { x: 0, opacity: 1 } : {}}
                    transition={{ duration: 0.8, ease: "easeOut" }}>
                    <TextSection>
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={productData[currentProduct].id}
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 50 }}
                                transition={{ duration: 0.5 }} >
                                <ContentContainer>
                                    <TitleContainer>
                                        <Texto>{productData[currentProduct].title}</Texto>
                                    </TitleContainer>

                                    <DescriptionContainer>
                                        <SectionTitle>Descripción del producto</SectionTitle>
                                        <DescriptionText>
                                            {productData[currentProduct].description}
                                        </DescriptionText>
                                    </DescriptionContainer>

                                    <CapacitiesContainer>
                                        <CapacityInfo>
                                            <SectionTitle>Capacidad del producto</SectionTitle>
                                            <CapacityButtons className="grid grid-cols-2 gap-4 place-items-center md:justify-center">
                                                {productData[currentProduct].capacities.features?.map(
                                                    (feature, index) => (
                                                        <CapacityButton
                                                            key={index}
                                                            className="flex flex-col items-center justify-center bg-white text-black rounded-lg p-2 shadow-lg leading-none"
                                                        >
                                                            <img
                                                                src={feature.logo}
                                                                alt={`Característica ${index + 1}`}
                                                                className="w-16 h-16 mb-2 object-contain"
                                                            />
                                                            <span className="text-center text-sm font-medium">
                                                                {feature.text}
                                                            </span>
                                                        </CapacityButton>
                                                    )
                                                )}
                                            </CapacityButtons>

                                            <div className="flex mt-6 justify-center">
                                                <button
                                                    onClick={() => setShowModal(true)}
                                                    className="bg-gradient-to-l from-[#2D4E86] to-[#29ABE2] text-white font-semibold py-2 px-6 rounded-full shadow-lg transition duration-300 border-2 border-sky-500"
                                                >
                                                    Más información
                                                </button>
                                            </div>
                                        </CapacityInfo>
                                    </CapacitiesContainer>
                                </ContentContainer>
                            </motion.div>
                        </AnimatePresence>
                    </TextSection>
                </motion.div>

                {/* Animación desde la derecha */}
                <motion.div
                    className="order-1 md:order-none"
                    initial={{ x: 300, opacity: 0 }}
                    animate={inView ? { x: 0, opacity: 1 } : {}}
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
                >
                    <ModelSection>
                        <div
                            style={{
                                width: "100%",
                                height: "100%",
                                position: "relative",
                                zIndex: 1,
                                backgroundImage: `url(${productData[currentProduct].background})`,
                                backgroundSize: "contain",
                                backgroundPosition: productData[currentProduct].backgroundPosition || "right",
                                backgroundRepeat: "no-repeat",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "0 2rem",
                            }}
                        >

                            {productData[currentProduct].id !== 4 && (
                                <button
                                    onClick={() => {
                                        setShowModal(true);
                                        setTab("modelo");
                                    }}
                                    className="z-30 bg-transparent border-none cursor-pointer md:p-[60px] p-4"
                                    style={{
                                        transition: "padding 0.3s ease",
                                    }}
                                >
                                    <img
                                        src={boton}
                                        alt="Ver modelo"
                                        className="w-12 h-12 md:w-[70px] md:h-[70px] object-contain md:ml-56 lg:ml-0"
                                    />
                                </button>
                            )}

                            <img
                                src={productData[currentProduct].modelImage}
                                alt={productData[currentProduct].title}
                                className={`
                                    absolute
                                    ${productData[currentProduct].imageSize.width}
                                    ${productData[currentProduct].imageSize.height}
                                    
                                    left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2  

                                    md:left-[40%] md:translate-x-0                    

                                    lg:left-1/2 lg:-translate-x-1/2                 

                                    z-[2]
                                `}
                            />
                        </div>
                    </ModelSection>
                </motion.div>
            </ContentWrapper>

            <ProductSelector>
                {productData.map((product, index) => (
                    <SelectorButton
                        key={product.id}
                        active={currentProduct === index}
                        onClick={() => {
                            setCurrentProduct(index);
                            setTab("medidas");
                        }}
                        data-index={index}
                    />
                ))}
            </ProductSelector>
            <AnimatePresence>
                {showModal && (
                    <motion.div
                        className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center px-4 py-4 md:py-0 overflow-y-auto"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <motion.div
                            className="bg-white bg-opacity-80 backdrop-blur-md rounded-2xl shadow-xl p-4 md:p-8 w-full max-w-5xl flex flex-col gap-4 md:gap-6 h-[90vh] md:h-auto md:max-h-[90vh] overflow-hidden"
                            initial={{ y: 50, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: 50, opacity: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            {/* HEADER - Mejorado para móvil */}
                            <div className="flex justify-between items-center mb-2 md:mb-0">
                                <h2 className="text-xl font-bold text-gray-800 md:hidden">
                                    {productData[currentProduct].title}
                                </h2>
                                <button
                                    onClick={() => {
                                        setShowModal(false);
                                        setTab("medidas");
                                    }}
                                    className="text-gray-700 hover:text-gray-900 text-3xl md:text-2xl"
                                >
                                    &times;
                                </button>
                            </div>

                            {/* CUERPO: Imagen + descripción - Mejorado para móvil */}
                            <div className="flex flex-col md:flex-row gap-4 md:gap-6 h-full overflow-y-auto">
                                {/* Contenedor de imagen - Ajustado para móvil */}
                                <div className="flex-1 flex justify-center items-center bg-white rounded-2xl min-h-[200px] md:min-h-[30rem]">
                                    {tab === "medidas" && (
                                        <img
                                            src={productData[currentProduct].modalInfo.medidas.imagen}
                                            alt="Medidas del producto"
                                            style={{
                                                width: productData[currentProduct].modalInfo.medidas.medidasImagen.ancho,
                                                height: productData[currentProduct].modalInfo.medidas.medidasImagen.alto,
                                                margin: productData[currentProduct].modalInfo.medidas.medidasImagen.margen,
                                                objectFit: "contain"
                                            }}
                                            className="max-w-full object-contain max-h-[180px] sm:max-h-[220px] md:max-h-[600px]"
                                        />
                                    )}

                                    {tab === "especificaciones" && (
                                        <img
                                            src={productData[currentProduct].modalInfo.especificaciones.imagen}
                                            alt="Especificaciones"
                                            style={{
                                                width: productData[currentProduct].modalInfo.especificaciones.medidasImagen.ancho,
                                                height: productData[currentProduct].modalInfo.especificaciones.medidasImagen.alto,
                                                margin: productData[currentProduct].modalInfo.especificaciones.medidasImagen.margen,
                                                objectFit: "contain"
                                            }}
                                            className="max-w-full object-contain max-h-[180px] sm:max-h-[220px] md:max-h-[600px]"
                                        />
                                    )}
                                    {tab === "preguntas frecuentes" && (
                                        <img
                                            src={productData[currentProduct].modalInfo.dudas.imagen}
                                            alt="Dudas frecuentes"
                                            style={{
                                                width: productData[currentProduct].modalInfo.dudas.medidasImagen.ancho,
                                                height: productData[currentProduct].modalInfo.dudas.medidasImagen.alto,
                                                margin: productData[currentProduct].modalInfo.dudas.medidasImagen.margen,
                                                objectFit: "contain"
                                            }}
                                            className="max-w-full object-contain max-h-[180px] sm:max-h-[220px] md:max-h-[300px]"
                                        />
                                    )}
                                    {tab === "modelo" && (
                                        <div
                                            ref={mountRef}
                                            className='modelo3d w-full h-[200px] sm:h-[250px] md:h-full rounded-md md:rounded-xl md:border md:border-gray-300 md:bg-[#f5f5f5] flex items-center justify-center relative'

                                        />
                                    )}
                                </div>

                                {/* Contenedor de texto - Ajustado para móvil */}
                                <div className="flex-1 text-gray-800 space-y-3 md:space-y-4 overflow-y-auto md:mt-12 px-2 md:px-0">
                                    {tab === "medidas" && (
                                        <>
                                            <Description className='inline'>
                                                {productData[currentProduct].modalInfo.medidas.descripcion}
                                            </Description>
                                            <ul className="space-y-1">
                                                <Content><li>Medidas: </li></Content>
                                                <li>Alto: <strong>{productData[currentProduct].modalInfo.medidas.alto}</strong></li>
                                                <li>Ancho: <strong>{productData[currentProduct].modalInfo.medidas.ancho}</strong></li>
                                                <li>Fondo: <strong>{productData[currentProduct].modalInfo.medidas.fondo}</strong></li>
                                            </ul>
                                            <p>
                                                <Description className='inline'>{productData[currentProduct].modalInfo.medidas.descripcion2}</Description>
                                            </p>
                                        </>
                                    )}
                                    {tab === "especificaciones" && (
                                        <>
                                            <Description>
                                                <ul className="list-disc ml-4 md:ml-6">
                                                    {productData[currentProduct].modalInfo.especificaciones.lista.map((item, index) => (
                                                        <li key={index} className="mb-1">{item}</li>
                                                    ))}
                                                </ul>
                                                {productData[currentProduct].id !== 4 && (
                                                    <a
                                                        href={productData[currentProduct].modalInfo.especificaciones.brochureUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="inline-block"
                                                    >
                                                        <button className="bg-gradient-to-l from-[#2D4E86] to-[#29ABE2] text-white font-semibold py-2 px-6 rounded-full shadow-lg transition duration-300 border-2 border-sky-500 mt-4 hover:from-[#1E3A8A] hover:to-[#1E81B0]">
                                                            Descargar Brochure
                                                        </button>
                                                    </a>
                                                )}
                                            </Description>
                                        </>
                                    )}
                                    {tab === "preguntas frecuentes" && (
                                        <div className="space-y-2">
                                            {productData[currentProduct].modalInfo.dudas.preguntas.map((item, index) => {
                                                const isOpen = openIndex === index;
                                                return (
                                                    <div key={index} className="border border-gray-300 rounded-lg overflow-hidden">
                                                        {/* Pregunta: sin fondo */}
                                                        <button
                                                            onClick={() => setOpenIndex(isOpen ? null : index)}
                                                            className="w-full text-left px-4 py-3 font-medium bg-transparent hover:bg-gray-50 transition flex justify-between items-center"
                                                        >
                                                            <span className="text-gray-800">{item.pregunta}</span>
                                                            <motion.span
                                                                animate={{ rotate: isOpen ? 180 : 0 }}
                                                                transition={{ duration: 0.2 }}
                                                                className="text-gray-500"
                                                            >
                                                                ▼
                                                            </motion.span>
                                                        </button>

                                                        {/* Respuesta: fondo claro */}
                                                        <AnimatePresence initial={false}>
                                                            {isOpen && (
                                                                <motion.div
                                                                    key="content"
                                                                    layout
                                                                    initial={{ opacity: 0, y: -10 }}
                                                                    animate={{ opacity: 1, y: 0 }}
                                                                    exit={{ opacity: 0, y: -10 }}
                                                                    transition={{ duration: 0.3 }}
                                                                    className="px-4 pb-4"
                                                                >
                                                                    <blockquote className="border-l-4 border-black pl-4 italic text-gray-800">
                                                                        {item.respuesta}
                                                                    </blockquote>
                                                                </motion.div>
                                                            )}

                                                        </AnimatePresence>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}


                                    {tab === "modelo" && (
                                        <>
                                            <Description>
                                                <p className="pt-2 md:pt-4">{productData[currentProduct].modalInfo.modelo.descripcion}</p>
                                                <img
                                                    src={productData[currentProduct].modalInfo.modelo.imagenGiro}
                                                    alt="Giro 360°"
                                                    className="my-3 w-24 sm:w-28 md:w-48 mx-auto"
                                                />
                                                <a
                                                    href={productData[currentProduct].modalInfo.modelo.whatsapp}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <button className="flex items-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white font-semibold py-2 px-4 rounded-full mx-auto shadow-md transition duration-300">
                                                        <FaWhatsapp className="text-xl" />
                                                        Contáctanos
                                                    </button>
                                                </a>
                                            </Description>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* TABS - Mejorado para móvil */}
                            <div className="mt-2 md:mt-0">
                                <div className="flex flex-wrap justify-center gap-2 md:gap-4">
                                    {tabs.map((t) => (
                                        <button
                                            key={t}
                                            className={`w-28 sm:w-32 md:w-36 lg:w-40 text-center px-2 md:px-4 py-1 md:py-2 rounded-full text-xs md:text-sm lg:text-base ${tab === t
                                                ? "bg-gray-100 text-[#2D4E86] font-semibold"
                                                : "bg-gray-200 text-[#2D4E86] hover:bg-gray-100"
                                                }`}
                                            onClick={() => setTab(t)}>
                                            {t.charAt(0).toUpperCase() + t.slice(1)}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </BannerContainer>
    );
};

// Nuevos estilos mejorados
const BannerContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, ${props => props.gradientStart}, ${props => props.gradientEnd});
  display: flex;
  flex-direction: column;

  @media (max-width: 1023px) {
    min-height: auto;
    padding-bottom: 40px;
  }

  @media (max-width: 767px) {
    min-height: 150vh;
  }
`;


const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  gap: 40px;
  width: 100%;
  padding: 0 5% 80px; // Padding inferior añadido
  box-sizing: border-box;
  align-items: center;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 40px;
    padding-bottom: 60px;
  }

  @media (max-width: 768px) {
    padding: 0 20px 40px;
    gap: 30px;
  }
`;

const TextSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  position: relative;
  z-index: 10;
  padding: 0 20px;

  @media (max-width: 768px) {
    order: 1;
    padding: 0 10px;
  }
`;

const ContentContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
`;

const TitleContainer = styled.div`
    margin-bottom: 2rem;
    text-align: center;

    @media (max-width: 768px) {
        margin-bottom: 1.5rem;
    }
`;

const DescriptionContainer = styled.div`
    margin-bottom: 3rem;

    @media (max-width: 768px) {
        margin-bottom: 2rem;
    }
`;

const CapacitiesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    order: 3;
  }
`;


const ImageContainer = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    order: 4;
    margin-top: 1rem;
  }
`;

const ProductImage = styled.img`
    width: 100%;
    height: auto;
   
`;

const CapacityInfo = styled.div`
    flex: 1;
    width: 100%;
`;

const CapacityButtons = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    
`;

const CapacityButton = styled.button`
  width: 230px;
  height: 160px;
  border: none;
  border-radius: 1rem;
  background: white;
  color: black;
  text-align: center;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 280px;
    height: 120px;
    margin: 0 auto;
    
    img {
      width: 48px;
      height: 48px;
    }
    
    span {
      font-size: 0.8rem;
    }
  }
`;



const SectionTitle = styled.h3`
    font-family: 'MiFuente';
    color: rgba(255, 255, 255, 0.8);
    text-transform: uppercase;
    margin-bottom: 1rem;
    position: relative;
    padding-bottom: 0.5rem;
    
    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 50px;
        height: 2px;
        background: white;
    }
`;

const DescriptionText = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 1rem;
    line-height: 1.5;
    padding: 0 10px;
  }
`;


const ModelSection = styled.div`
  flex: 1;
  height: 80vh;
  width: 50vw;
  min-height: 600px;
  position: relative;
  z-index: 1;
  margin: auto;
  overflow: visible;
  padding-top: 80px;

  @media (min-width: 768px) and (max-width: 1023px) {
    /* Estilos específicos para tablet */
    height: 40vh;
    min-height: 400px;
    padding-top: 5px;
    left: auto;
    width: 100vw;
  }

  @media (min-width: 1024px) {
    left: 100px;
  }

  @media (max-width: 767px) {
    height: 50vh;
    width: 100vw;
    min-height: 300px;
    padding-top: 40px;
    left: 30px;
  }
`;


const ProductSelector = styled.div`
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 15px;
  z-index: 5;

  @media (max-width: 1024px) {
    position: static;
    flex-direction: row;
    justify-content: center;
    transform: none;
    margin-top: 20px;
    padding: 10px 0;
  }

  @media (max-width: 768px) {
    gap: 10px;
    margin-top: 30px;
  }
`;

const SelectorButton = styled.button`
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: none;
    background-color: ${({ active }) => (active ? "#fff" : "rgba(255, 255, 255, 0.5)")};
    transition: background-color 0.3s ease;
    cursor: pointer;

    &:hover {
        background-color: rgba(255, 255, 255, 0.8);
    }

    @media (max-width: 768px) {
        width: 20px;
        height: 20px;
    }
`;


const Texto = styled.h1`
  font-family: 'MiFuente';
  font-size: 3.5rem;
  color: white;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.6);
  margin-bottom: 1.5rem;

  @media (max-width: 1024px) {
    font-size: 3rem;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    text-align: center;
    margin-bottom: 1rem;
  }
`;


const Description = styled.p`
  font-size: 1rem;
  font-family: 'MiFuente2';

  @media (min-width: 768px) {
    font-size: 1.1rem;
  }

  @media (min-width: 1024px) {
    font-size: 1.2rem;
  }
`;

const Content = styled.p`
  font-family: 'MiFuente';
  font-size: 1rem;

  @media (min-width: 768px) {
    font-size: 1.1rem;
  }

  @media (min-width: 1024px) {
    font-size: 1.2rem;
  }
`;


export default Banner3;